import { NonceLimitResult } from '@/services/apis/tx/models'

export const showNonceTip = (nonce: string | number, nonceLimit: NonceLimitResult): boolean => {
  return (
    nonceLimit.maxUseNonce > nonceLimit.chainNonce &&
    Number(nonce) >= nonceLimit.chainNonce &&
    Number(nonce) <= nonceLimit.maxUseNonce
  )
}
